import { yup } from '@guiker/shared-framework'

export const searchQueryParams = yup.object({
  searchString: yup.string().required(),
  entities: yup.array().of(yup.string()).nullable(),
  scopeId: yup.string().nullable(),
  scopeType: yup.string().nullable(),
})
